import React from 'react';
import { DashboardTelemetryProvider } from '@apps/admin/routes/Dashboard/Dashboard.telemetry';
import { DashboardContentV2 } from '@apps/admin/routes/Dashboard/components/DashboardContentV2/DashboardContentV2';
import { GlobalStyle } from './common/commonDasboard.styles';
import { DashboardData } from './useDashboardData';
import { InviteAdminDialogProvider } from '@shared/context/InviteAdminDialog/InviteAdminDialog.provider';
import { useTranslation } from '@shared/core';
import { JoyLogoLoader } from '@shared/components/JoyLogoLoader';

export interface DashboardProps {
  eventHandle: string;
  dashboardData: DashboardData;
}

export type HandleShareDialogOpen = (args: { guestSiteLink: string; eventPassword: string }) => void;

export const Dashboard: React.FC<DashboardProps> = props => {
  const { t2 } = useTranslation('adminDashboardV2');
  const { title: InviteAdminDialogTitle } = t2('inviteAdminDialog');

  // Add this section back in if ReEngagementPopup is removed from DashboardContentV2
  // useToggleIntercomLauncher({
  //   show: !props.dashboardData.loading,
  //   minScreenSize: 'mobile'
  // });

  if (props.dashboardData.loading) {
    // Adding a loader here so that the parent query has time to resolve before rendering the UI
    // which depends on data for certain feature flags
    return <JoyLogoLoader loaderKey="admin-dashboard" />;
  }

  const eventDisplayName = props.dashboardData.data?.eventByName?.info?.eventDisplayName || props.dashboardData.dataV3?.eventByName?.info?.eventDisplayName || '';
  const eventId = props.dashboardData.data?.eventByName?.id || props.dashboardData.dataV3?.eventByName?.id || '';

  return (
    <DashboardTelemetryProvider context={{ eventId }}>
      <GlobalStyle />
      <InviteAdminDialogProvider eventId={eventId} title={InviteAdminDialogTitle}>
        <DashboardContentV2 {...props} eventDisplayName={eventDisplayName} eventId={eventId} />
      </InviteAdminDialogProvider>
    </DashboardTelemetryProvider>
  );
};
